import { IDeviceAccumulatedEventDto } from './device-events-with-devices-output.dto.interface';

export interface IDevicePositionsWithDevicesAndEventsResponse {
    devices: {
        deviceId: number;
        deviceExternalId?: string;
        coordinates: {
            lat: string;
            lng: string;
            heading: number;
            speed: number;
            timestamp: string;
            event?: IDeviceAccumulatedEventDto;
        }[];
    }[];
}
